import {addEvent, isNotEmpty, removeEvent} from "@/tools/utils";
import {ref,onMounted} from 'vue'
import dom from 'quasar/src/utils/dom.js';import Platform from 'quasar/src/plugins/Platform.js';;
/**
 * 显示区高度
 * @type {{data(): *, methods: {handleResizeWindow(): void}, mounted(): void, beforeDestroy(): void}}
 */
export const innerHeight = {
    data() {
        return {
            innerHeight: 0,
        };
    },
    methods: {
        /**
         * 判断GET_LAYOUT若为警务传统布局则innerHeight直接减去180
         */
        handleResizeWindow() {
            if(!Platform.is.mobile){
                this.innerHeight = window.innerHeight;
            }else{
                this.innerHeight = null
            }
        },
    },
    mounted() {
        this.handleResizeWindow();
        addEvent(window, 'resize', this.handleResizeWindow);
    },
    beforeDestroy() {
        removeEvent(window, 'resize', this.handleResizeWindow);
    },
};

export const useMyInnerHeight = ()=>{
    let innerHeight = ref(0);
    let setInnerHeight = ()=>{
        if(!Platform.is.mobile){
            innerHeight.value = window.innerHeight;
        }else{
            innerHeight.value = null
        }
    }
    onMounted(()=>{
        setInnerHeight();
        window.onresize = () => {
            return (() => {
                setInnerHeight();
            })();
        };
    });
    return {innerHeight}
}

/**
 * 显示区宽度
 * @type {{data(): *, methods: {handleResizeWindow(): void}, mounted(): void, beforeDestroy(): void}}
 */
export const innerWidth = {
    data() {
        return {
            innerWidth: 0,
        };
    },
    methods: {
        handleResizeWindowWidth() {
            this.innerWidth = window.innerWidth;
        },
    },
    mounted() {
        this.innerWidth = window.innerWidth;
        addEvent(window, 'resize', this.handleResizeWindowWidth);
    },
    beforeDestroy() {
        removeEvent(window, 'resize', this.handleResizeWindowWidth);
    },
};
